import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { App } from './App';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { EmailOtpPage } from './pages/EmailOtpPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { SignUpPage } from './pages/SignUpPage';
import { StoresListPage } from './pages/StoresListPage';
import { DevicePage } from './pages/DevicePage';
import { ScenarioPage } from './pages/ScenarioPage';
import { StatusDataPage } from './pages/StatusDataPage';
import { ProductsPage } from './pages/ProductsPage';
import { MediaLibraryPage } from './pages/MediaLibraryPage';
import { TagsPage } from './pages/TagsPage';
import { BigDevicePage } from './pages/BigDevicePage/BigDevicePage';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { BusinessRoute } from './components/ProtectedRoute/ProtectedRoute';
import { MyDisplaysPage } from './pages/MyDisplaysPage';
import { PersonalMediaPage } from './pages/PersonalMediaPage/PersonalMediaPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { PersonalMediaLibraryProvider } from './contexts/PersonalMediaLibraryContext';
import { BusinessProviders } from './components/BusinessProviders';

export const Root = () => {
  return (
    <AuthProvider>
      <BusinessProviders>
        <PersonalMediaLibraryProvider>
          <Router>
            <Routes>
              <Route path="/" element={<App />}>
                <Route index element={<LoginPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/email-otp" element={<EmailOtpPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/sign-up" element={<SignUpPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

                <Route element={<ProtectedRoute />}>
                  <Route path="/my-displays" element={<MyDisplaysPage />} />
                  <Route path="/my-media" element={<PersonalMediaPage />} />
                </Route>

                <Route element={<BusinessRoute />}>
                  <Route path="/stores" element={<StoresListPage />} />
                  <Route path="/displays" element={<BigDevicePage />} />
                  {/* <Route path="/labels" element={<DevicePage />} /> */}
                  <Route path="/scenario" element={<ScenarioPage />} />
                  <Route path="/device-map" element={<StatusDataPage />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/media-library" element={<MediaLibraryPage />} />
                  <Route path="/tags" element={<TagsPage />} />
                </Route>

                {/* <Route path="*" element={<NotFoundPage />} /> */}
              </Route>
            </Routes>
          </Router>
        </PersonalMediaLibraryProvider>
      </BusinessProviders>
    </AuthProvider>
  );
};
